import {
  defineNotificationWorkflow,
  notificationWorkflowKeyFromEnum,
} from '@app/modules/notifications/workflows/notification-workflow';
import { NotificationsAodDeficiencyBreachedNotificationDtoWorkflowKeyEnum } from '@mi-front/api-v2';
import { defineMessage } from 'react-intl';
import { aodRoutes } from '../routing/routes';

/**
 * Knock workflow: AOD run fell below minimum efficiency.
 * Primary click opens the run view built from `runId` (not backend `runUrl`).
 */
export const aodDeficiencyBreachedWorkflow = defineNotificationWorkflow({
  key: notificationWorkflowKeyFromEnum(
    NotificationsAodDeficiencyBreachedNotificationDtoWorkflowKeyEnum,
  ),
  category: 'audit',
  channels: { inApp: true, email: true },
  severity: 'warning',
  preference: {
    title: defineMessage({
      id: 'notifications.preferences.workflow.aodDeficiencyBreached.title',
      defaultMessage: 'Eficiencia AOD insuficiente',
    }),
    description: defineMessage({
      id: 'notifications.preferences.workflow.aodDeficiencyBreached.description',
      defaultMessage: 'Cuando una ejecución de AOD no alcanza el umbral mínimo de eficiencia',
    }),
  },
  actionUrl: (data) => (data.runId.length > 0 ? aodRoutes.runView.gen(data.runId) : null),
});
